var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaundry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Laundry a shirt") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laundry_a_shirt",
    "data-name": "Laundry a shirt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.55,4.17A1,1,0,1,0,5.19,6,1,1,0,0,0,5.55,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29,4.29A1,1,0,0,0,9.71,5.71,1,1,0,0,0,8.29,4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.62,4.08a1,1,0,1,0,1.09.21A1,1,0,0,0,12.62,4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,4H23a1,1,0,0,0,0,2H33A1,1,0,0,0,33,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.22,35A3,3,0,0,0,45,30H38V4a4,4,0,0,0-4-4H4A4,4,0,0,0,0,4V40a4,4,0,0,0,4,4H22.1A5,5,0,0,0,27,48H45a3,3,0,0,0,2.22-5,3,3,0,0,0,0-4A3,3,0,0,0,47.22,35ZM45,34H27a1,1,0,0,0,0,2H45a1,1,0,0,1,0,2H27a3,3,0,0,1,0-6H45A1,1,0,0,1,45,34ZM29.23,30H27.05a9,9,0,1,0-5,4.45,3.93,3.93,0,0,0,.2,2.06,11,11,0,1,1,7-6.51ZM12,25.4c1.42-.27,1.59-.9,3-.9,1.59,0,1.82,1,4,1s2.39-1,4-1c1.36,0,1.55.63,3,.9A7,7,0,1,1,12,25.4Zm.63-2.35a7,7,0,0,1,12.68,0,5.17,5.17,0,0,0-4.78.05,3.17,3.17,0,0,1-3.1,0A5.19,5.19,0,0,0,12.66,23.05ZM2,4A2,2,0,0,1,4,2H34a2,2,0,0,1,2,2V8H2ZM2,40V10H36V30H31.37a13,13,0,1,0-8.12,8.27A4.89,4.89,0,0,0,24,39a5,5,0,0,0-1.93,3H4A2,2,0,0,1,2,40Zm43,6H27a3,3,0,0,1,0-6H45a1,1,0,0,1,0,2H27a1,1,0,0,0,0,2H45A1,1,0,0,1,45,46Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaundry);
export default __webpack_public_path__ + "static/media/laundry.31b0b298fd07976620d43dc44566e8f1.svg";
export { ForwardRef as ReactComponent };